import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { POST } from 'src/app/util/constants';
import Swal from 'sweetalert2';
import { WebserviceService } from '../services/webservice.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralIdResolver implements Resolve<unknown> {
  referralId!: string;
  userDetails: unknown;

  constructor(private _service: WebserviceService, private _router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<unknown> {
    const queryString = window.location.search;

    if (queryString) {
      const key = queryString.substring(1, queryString.indexOf('='));
      if (
        [
          'reg',
          'onpassive',
          'invt',
          'myInv',
          'webinarid',
          'id',
          'grt',
        ].includes(key)
      ) {
        const params = new URLSearchParams(queryString);
        this.referralId = params.get(key);

        return this._service
          .commonMethod(
            'checkUserByReferralId',
            { encryptId: this.referralId },
            POST
          )
          .pipe(
            map((res: unknown) => {
              if (res) {
                return res;
              } else {
                Swal.fire(
                  'Your registration link is not valid',
                  'Please contact your invitee.',
                  'warning'
                ).then((data) => {
                  return this.routeToLogin();
                });
              }
            }),
            catchError((err) => {
              return this.routeToLogin();
            })
          );
      } else {
        return this.routeToLogin();
      }
    } else {
      return this.routeToLogin();
    }
  }

  private routeToLogin() {
    this._router.navigate(['/']);
    return EMPTY;
  }
}
